<section class="section" *ngIf="sections2">
    <div class="card-container">
        <ng-container *ngFor="let setting of sections2.actions">
            <a class="action-card" [class.disabled]="!setting.route" (click)="openItemToNewTab(setting.route)" href="javascript:void(0)" rel="noopener">
                <img [src]="setting.icon" alt="Templates icon" />
                <h3>{{setting.title}}</h3>
                <p>{{setting.description}}</p>
            </a>
        </ng-container>
    </div>
</section>


<!-- <section class="section" *ngIf="sections4">
        <h2><i class="fa-solid fa-gear"></i>&nbsp;&nbsp;{{ sections4.title }}</h2>
        <div class="settings-grid">
            <div class="settings-item" *ngFor="let setting of sections4.settings">
                <h3>{{ setting.title }}</h3>
                <p>{{ setting.description }}</p>
               <a *ngIf="setting.route"
                [routerLink]="getSettingRoute(setting.route)"
                class="text-link">
                {{ setting.linkText }} <i class="fa-regular fa-arrow-right"></i>
                </a>
            </div>
        </div>
    </section> -->